import { NgIf } from '@angular/common'
import { Component, OnInit, ViewChild } from '@angular/core'
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router'
import { bounceAnimation } from 'angular-animations'
import { CurrentAuthenticatedUserDto, SignalRUserService } from 'app/shared/generated/generated'
import { AppConfigService } from 'app/shared/services/app-config.service'
import { Message, PrimeNGConfig } from 'primeng/api'
import { ConfirmDialogModule } from 'primeng/confirmdialog'
import { Toast, ToastModule } from 'primeng/toast'
import { SafePipe } from './core/pipes/safe.pipe'
import {
  GlobalMessagingEventsConstants,
  SignalRAdminService,
  SignalRGlobalMessageService,
} from './shared/generated/generated'
import { ThemeService } from './shared/services/app-theme.service'
import { CurrentUserService } from './shared/services/current-user.service'
import { MessageBusService } from './shared/services/message-bus.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [bounceAnimation()],
  standalone: true,
  imports: [NgIf, RouterOutlet, SafePipe, ToastModule, ConfirmDialogModule],
})
export class AppComponent implements OnInit {
  @ViewChild('globalToast') globalToast: Toast
  @ViewChild('debugToast') debugToast: Toast

  constructor(
    private primengConfig: PrimeNGConfig,
    private themeService: ThemeService,
    private currentlyAuthorizedUserService: CurrentUserService,
    private messageBusService: MessageBusService,
    private router: Router,
    public appConfigService: AppConfigService,
    private signalRGlobalMessageService: SignalRGlobalMessageService,
    private SignalRAdminService: SignalRAdminService,
    private signalRUserService: SignalRUserService,
    private route: ActivatedRoute //private router: Router
  ) {}

  currentUser: CurrentAuthenticatedUserDto

  ngOnInit() {
    this.currentlyAuthorizedUserService.clearUserSessionData()
    this.primengConfig.ripple = true
    document.documentElement.style.fontSize = '14px'
    this.themeService.initialize()

    this.messageBusService.addedMessage$.subscribe((message: Message) => {
      if (this.debugToast && message.key && message.key == 'debuggingToast') {
        this.debugToast.add([message])
      } else {
        this.globalToast.add([message])
      }
    })

    this.route.queryParams.subscribe((params) => {
      this.handleNotificationsFromQueryParameters(params)
    })
  }

  title = this.appConfigService.getApplicationName()

  private handleNotificationsFromQueryParameters(paramaters: any) {
    if (paramaters[GlobalMessagingEventsConstants.successToast]) {
      this.messageBusService.addSuccessToast(paramaters[GlobalMessagingEventsConstants.successToast])
    }
    if (paramaters[GlobalMessagingEventsConstants.successNotification]) {
      this.messageBusService.addSuccessNotification(paramaters[GlobalMessagingEventsConstants.successNotification])
    }
    if (paramaters[GlobalMessagingEventsConstants.errorToast]) {
      this.messageBusService.addErrorToast(paramaters[GlobalMessagingEventsConstants.errorToast])
    }
    if (paramaters[GlobalMessagingEventsConstants.errorNotification]) {
      this.messageBusService.addErrorNotification(paramaters[GlobalMessagingEventsConstants.errorNotification])
    }
  }
}
